import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Supplier } from "../../models/supplier.model";

import { SupplierService } from "../../services/supplier.service";

@Component({
  selector: "ngx-dialog-link-supplier",
  templateUrl: "dialog-link-supplier.component.html",
  styleUrls: ["dialog-link-supplier.component.scss"],
})
export class DialogLinkSupplierComponent implements OnInit {
  @Input() header: string;
  @Input() shopId?: string;
  @Input() linkSupplierId: string;
  @Input() suppliers?: Supplier[];

  diaForm: FormGroup;
  loading = false;
  submitted = false;
  strSearch = "";
  mobile = "";

  constructor(
    protected ref: NbDialogRef<DialogLinkSupplierComponent>,
    private fb: FormBuilder,
    private supplierService: SupplierService
  ) {}

  ngOnInit() {
    const fullNameValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    const mobileValidators = [Validators.required];
    this.diaForm = this.fb.group({
      fullName: ["", fullNameValidators],
      mobile: ["", mobileValidators],
    });
  }

  cancel() {
    this.ref.close();
  }

  //Create
  create() {
    let cus = new Supplier();
    cus.shopId = this.shopId;
    cus.fullName = this.strSearch.trim();
    cus.mobile = this.mobile.trim();

    if (cus.fullName.length > 0) {
      this.loading = true;
      this.submitted = true;

      this.supplierService
        .create(cus)
        .then((data) => {
          this.selected(JSON.parse(JSON.stringify(data)));
        })
        .catch((err) => {
          this.loading = false;
          this.submitted = false;
        });
    }
  }

  selected(item) {
    this.submitted = true;
    this.ref.close(item);
  }

  removeLink() {
    this.submitted = true;
    const value = {
      id: "",
    };
    this.ref.close(value);
  }
}
